import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { CoreConfigService } from '@core/services/config.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-auth-forgot-password-page',
  templateUrl: './auth-forgot-password-page.component.html',
  styleUrls: ['./auth-forgot-password-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthForgotPasswordPageComponent implements OnInit {

   // Public
   public emailVar;
   public coreConfig: any;
   public forgotPasswordForm: FormGroup;
   public submitted = false;
 
   // Private
   private _unsubscribeAll: Subject<any>;
 
   /**
    * Constructor
    *
    * @param {CoreConfigService} _coreConfigService
    * @param {FormBuilder} _formBuilder
    *
    */
   constructor(private _coreConfigService: CoreConfigService, 
               private _formBuilder: FormBuilder,
               private _router: Router,
               private authService: AuthService) {
     this._unsubscribeAll = new Subject();
 
     // Configure the layout
     this._coreConfigService.config = {
       layout: {
         navbar: {
           hidden: true
         },
         footer: {
           hidden: true
         },
         menu: {
           hidden: true
         },
         customizer: false,
         enableLocalStorage: false
       }
     };
   }
 
   // convenience getter for easy access to form fields
   get f() {
     return this.forgotPasswordForm.controls;
   }
 
   /**
    * On Submit
    */
  


   onSubmit() {
    Swal.fire({
      title: 'Pronto recibirás un correo electrónico para restablecer tu contraseña. Revisa la carpeta de spam y la papelera si no encuentras el correo electrónico.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if(result.value) {
        this.submitted = true;
 
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }
 
    // Login
    //this.loading = true;
    let mail: any = this.forgotPasswordForm.controls['email'].value;
        this.authService.mailConfirmation(mail).subscribe((resp) => {
        //localStorage.setItem('access_token', resp.access_token);
       });
       Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Correo de confirmacion enviado',
        text: 'Porfavor ingresa a tu correo y sigue los pasos que se indican allí',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1000
       })
       this._router.navigate(['']);
      }
    })
    
 
    // redirect to home page
    //setTimeout(() => {
    //  this._router.navigate(['/dashboard/folders']);
   // }, 100);
 
  }
 
   // Lifecycle Hooks
   // -----------------------------------------------------------------------------------------------------
 
   /**
    * On init
    */
   ngOnInit(): void {
     this.forgotPasswordForm = this._formBuilder.group({
       email: ['', [Validators.required, Validators.email]]
     });
 
     // Subscribe to config changes
     this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
       this.coreConfig = config;
     });
   }
 
   /**
    * On destroy
    */
   ngOnDestroy(): void {
     // Unsubscribe from all subscriptions
     this._unsubscribeAll.next();
     this._unsubscribeAll.complete();
   }
 }
 